import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container, Navbar } from "shards-react";

import NavbarSearch from "./NavbarSearch";
import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarToggle from "./NavbarToggle";

/**
 * Componente que muestra la barra de navegación principal.
 * @name MainNavbar
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.layout - El tipo de diseño donde se usa la barra de navegación principal.
 * @param {boolean} props.stickyTop - Indica si la barra de navegación principal se mantiene pegada en la parte superior o no.
 * @returns {JSX.Element} - Elemento JSX que representa la barra de navegación principal.
*/

const MainNavbar = ({ layout, stickyTop }) => {
/**
 * Clases CSS para estilizar la barra de navegación principal.
 * @type {string}
*/
  const classes = classNames(
    "main-navbar",
    "bg-white",
    stickyTop && "sticky-top"
  );

  return (
    <div className={classes}>
      <Container className="p-0">
        <Navbar type="light" className="align-items-stretch flex-md-nowrap p-0">
          <NavbarSearch />
          <NavbarNav />
          <NavbarToggle />
        </Navbar>
      </Container>
    </div>
  );
};
/**
 * Tipos de las propiedades del componente MainNavbar.
 * @type {Object}
 * @property {string} layout - El tipo de diseño donde se usa la barra de navegación principal.
 * @property {boolean} stickyTop - Indica si la barra de navegación principal se mantiene pegada en la parte superior o no.
*/
MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool
};
/**
 * Propiedades por defecto del componente MainNavbar.
 * @type {Object}
 * @property {boolean} stickyTop - Indica si la barra de navegación principal se mantiene pegada en la parte superior o no.
*/
MainNavbar.defaultProps = {
  stickyTop: true
};

export default MainNavbar;
